import * as React from "react";
import { Toggletip as Toggletip$1 } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const Toggletip = (props) => {
  const { getLabel } = useIntl();
  const ariaLabel = props["aria-label"] ?? getLabel("common.tooltip");
  return /* @__PURE__ */ React.createElement(Toggletip$1, { ...props, ariaLabel, "data-t": "tooltip" });
};
export {
  Toggletip
};
//# sourceMappingURL=Toggletip.js.map
